<template>
  <v-card class="forgotPasswordForm_card">
    <h2 class="forgotPasswordForm_title">
      SECOM Sights ID パスワードのリセット
    </h2>
    <section class="forgotPasswordForm_caption">
      <h3 class="forgotPasswordForm_caption-text">認証コードを送信します</h3>
    </section>
    <p class="forgotPasswordForm_desc">
      パスワードの再設定をするために、認証コードをお送りします。<br />
      認証コードをお送りする、ログイン用のメールアドレスを入力してください。
    </p>
    <div v-if="errorMessage" class="forgotPasswordForm_error-wronginfo">
      {{ errorMessage }}
    </div>

    <ValidationObserver
      ref="observer"
      v-slot="{ invalid }"
      tag="div"
      class="forgotPasswordForm_content"
    >
      <section class="forgotPasswordForm_container">
        <ValidationProvider
          v-slot="{ errors }"
          vid="email"
          name="メールアドレス"
          rules="required|email"
          class="forgotPasswordForm_input"
        >
          <h4
            class="forgotPasswordForm_container_item"
            :class="{
              ['forgotPasswordForm_container_item--error']: errors.length,
            }"
          >
            メールアドレス
          </h4>

          <v-text-field
            v-model="email"
            class="forgotPasswordForm_container_input"
            :error-messages="errors"
            color="dark"
            required
            full-width
            type="email"
          />
        </ValidationProvider>
      </section>
      <div class="forgotPasswordForm_btn_container">
        <v-btn
          block
          depressed
          large
          color="primary"
          class="forgotPasswordForm_btn"
          :disabled="invalid"
          :loading="loading"
          @click="handleSubmit"
        >
          認証コードを送信
        </v-btn>
      </div>
    </ValidationObserver>
    <footer class="forgotPasswordForm_footer">
      <v-btn text @click="handleBack">もどる</v-btn>
    </footer>
  </v-card>
</template>

<script>
export default {
  name: 'ForgotPasswordForm',
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    errorMessage: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      valid: true,
      email: '',
    };
  },
  watch: {
    errorMessage(val) {
      if (val) {
        this.$refs.observer.setErrors({ email: [''] });
      } else {
        this.$refs.observer.setErrors({ email: [] });
      }
    },
  },
  methods: {
    handleBack() {
      this.routerPushLogin();
    },
    handleSubmit() {
      this.$emit('submit', {
        email: this.email,
      });
    },
    handleCancel() {
      this.$emit('cancel');
    },
  },
};
</script>

<style lang="scss">
.forgotPasswordForm {
  &_card {
    width: 500px;
    height: 500px;
    overflow: hidden;
    margin: 0 auto;
    margin-bottom: 30px;
    &.v-sheet.v-card:not(.v-sheet--outlined) {
      padding: 102px;
      padding-top: 40px;
      box-shadow: 0 3px 12px 0 rgba(0, 0, 0, 0.06);
      background-color: #fff;
      border-radius: 10px;
    }
    .v-btn:not(.v-btn--round).v-size--large {
      height: 48px;
      border-radius: 10px;
    }

    .v-btn__content {
      font-weight: bold;
    }
    .theme--light.v-btn.v-btn--disabled.v-btn--has-bg {
      background-color: #eeeeee !important;
    }
  }
  &_title {
    font-size: 16px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.44;
    letter-spacing: normal;
    text-align: center;
    color: #333;
  }
  &_desc {
    font-size: 12px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.33;
    letter-spacing: normal;
    text-align: left;
    color: #666;
  }
  &_caption {
    margin: 20px auto 29px;
    display: flex;
    align-items: center;
    justify-content: center;
    &-text {
      text-align: center;
      font-size: 14px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      letter-spacing: normal;
      color: #4b4b4b;
    }
    &-icon {
      margin-top: 3px;
    }
  }
  &_container {
    display: flex;
    flex-direction: column;
    &_item {
      font-size: 12px;
      font-weight: 600;
      line-height: 16px;
      height: 16px;
      color: #333333;
      &--error {
        color: var(--v-error-base);
      }
    }
    &_input {
      width: 100%;
      margin-bottom: 20px;
      margin-top: 0;
      padding-top: 0;
      .v-input {
        font-size: 18px;
      }
      .v-text-field__slot {
        padding-left: 0;
      }
      .v-input__slot {
        min-height: 40px !important;
      }
      input {
        line-height: 32px !important;
        color: var(--text-color) !important;
        font-size: 18px !important;
        font-weight: normal !important;
        font-stretch: normal !important;
        font-style: normal;
        letter-spacing: normal;
        text-align: left;
        &:-webkit-autofill,
        &:-webkit-autofill::first-line {
          font-family: 'Noto Sans JP', sans-serif;
          font-size: 18px;
          font-weight: 500;
        }
      }
    }
  }

  &_input {
    margin-top: 4px;
    &-label {
      font-size: 14px;
      font-weight: 500;
      font-stretch: normal;
      font-style: normal;
      letter-spacing: 0.7px;
      text-align: left;
      color: var(--text-color-2);
      margin-right: 20px;
    }
    &-code {
      &.v-text-field {
        max-width: 168px;
        font-size: 40px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        letter-spacing: 2px;
        text-align: center;
        color: var(--text-color);
        &.theme--light.v-input input {
          max-width: 168px;
          max-height: 70px;
          text-align: center;
        }
      }
    }
  }

  &_btn {
    &_container {
      text-align: center;
      margin-bottom: 20px;
    }
    &-return {
      margin-top: 20px;
      &.theme--light.v-btn.v-btn--has-bg.primary {
        border-radius: 10px;
        box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.16);
        background-color: #fff !important;
        font-size: 14px;
        font-weight: bold;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.5;
        letter-spacing: normal;
        text-align: center;
        color: #0075c2;
      }
    }
  }

  &_content {
    display: flex;
    margin: 0 auto;
    justify-content: center;
    flex-direction: column;
    form {
      width: 100%;
      padding: 0 40px;
    }
    &-item {
      p {
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        letter-spacing: normal;
        text-align: center;
        color: #666;
      }
    }
  }
  &_footer {
    text-align: center;
    .v-btn {
      .v-btn__content {
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.5;
        letter-spacing: normal;
        text-align: center;
        color: #0075c2;
      }
    }
  }
  &_error {
    &-wronginfo {
      height: 5px;
      font-size: 15px;
      font-weight: normal;
      line-height: 1.4;
      text-align: left;
      color: var(--error-color);
      margin: 0 auto;
      margin-top: -10px;
      margin-bottom: 25px;
      text-align: center;
    }
    &-gap {
      height: 30px;
    }
  }
}
</style>
